import { Box, Flex, Select, Text } from "@radix-ui/themes";
import { useProximityScreenZoneListQuery } from "../../api/zone-api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function RecipeZone() {
  const { data: zones } = useProximityScreenZoneListQuery();
  const [currentZone, setCurrentZone] = useState<string | null>(null);
  const navigate = useNavigate();

  return (
    <Flex className="h-screen" align="center" justify="center">
      <Box>
        <Text as="p" weight="medium" mb="2">
          Select Proximity Zone
        </Text>
        <Select.Root
          defaultValue={currentZone || ""}
          onValueChange={(value) => {
            setCurrentZone(value);
            navigate(`${value}`);
          }}
        >
          <Select.Trigger placeholder="Select zone" />
          <Select.Content>
            {zones?.map((zone) => (
              <Select.Item key={zone.screen_zone_id} value={zone.screen_zone_id}>
                {zone.screen_zone_id}
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Root>
      </Box>
    </Flex>
  );
}
